import { Controller } from "@hotwired/stimulus"
import Bridge from "../src/turbo_native/bridge"

export default class extends Controller {
  static values = { url: String }

  sendRequest(event) {
    if (Bridge.isTurboNativeApp) {
      event.preventDefault()
      event.stopImmediatePropagation()
      fetch(this.urlValue, { headers: { accept: "application/json" } })
        .then(response => response.json())
        .then(data => {
          window.TurboNativeBridge.postMessage("saveOffline", data)
        })
    }
  }
}
